import { useMutation } from "@tanstack/react-query";
import * as yup from "yup";
import { http } from "../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../consts/api";

const requestSchema = yup.object({
  mergedInvoiceId: yup.number().required(),
  tipAmount: yup.number().required(),
});

export function useAddMergedInvoiceTipMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    return http.post(HTTP_ENDPOINTS.postMergedInvoiceTip(), {
      invoice_id: req.mergedInvoiceId,
      tip_amount: req.tipAmount,
    });
  }, options);
}
